<template>
  <div>
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="2000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button
        class="md-primary md-simple md-dense"
        @click="snackbar.show = false"
      >Dismiss
      </md-button
      >
    </md-snackbar>
    <ValidationObserver v-slot="{invalid, errors}">
      <group-card :title="cardTitle" icon="people">
        <div class="boxed-category">
          <div class="md-layout input-layout">
            <!--Name -->
            <validated-text-input
              v-model="formData.name"
              class="md-layout-item md-small-size-100 md-size-51"
              label="Name"
              required
            >
            </validated-text-input>
            <!--URL Key -->
            <validated-text-input
              v-model="formData.key"
              class="md-layout-item md-small-size-100 md-size-51"
              label="URL Key"
              required
              alpha-dash
              errormsg="Please enter a valid key, special characters are not allowed other than - and _."
            >
            </validated-text-input>
            <!-- Parent Step -->
            <validated-select-input
              v-model="formData.parent_id"
              :options="parentStepOptions"
              class="md-layout-item md-size-51"
              label="Parent Step"
            ></validated-select-input>
          </div>
        </div>
        <!-- details -->
        <div class="boxed-category">
          <md-subheader>Details</md-subheader>
          <div class="md-layout">
            <!-- Title -->
            <validated-text-input
              v-model="formData.metadata.details.title"
              class="md-layout-item md-small-size-100 md-size-50"
              label="Title"
              required
            >
            </validated-text-input>
            <!-- Description -->
            <validated-text-input
              v-model="formData.metadata.details.description"
              class="md-layout-item md-small-size-100 md-size-50"
              label="Description"
              required
              :maxLength="255"
              errormsg="Description can be maximum of 255 characters in length."
            >
            </validated-text-input>
          </div>
        </div>
        <!-- Transition Condition -->
        <div class="boxed-category">
          <md-subheader>Transition Condition</md-subheader>
          <div class="md-layout">
            <!--Path -->
            <div class="md-layout-item md-small-size-100 md-size-20">
              <validated-text-input
                v-model="newCondition.path"
                class="md-layout-item md-small-size-100 md-size-20"
                label="Path"
              >
              </validated-text-input>
              <span v-if="transitionError.path" class="error-message">{{ transitionError.path }}</span>
            </div>
            <!-- Comparison -->
            <div class="md-layout-item md-small-size-100 md-size-20">
              <validated-select-input
                v-model="newCondition.comparison"
                :options="comparisonOptions"
                class="md-layout-item md-size-20"
                label="Comparison"
              ></validated-select-input>
              <span v-if="transitionError.comparison" class="error-message">{{ transitionError.comparison }}</span>
            </div>
            <!-- Condition State Key or Value -->
            <div class="md-layout-item md-small-size-100 md-size-20">
              <validated-text-input
                v-model="newCondition.condition"
                class="md-layout-item md-small-size-100 md-size-20"
                label="Condition State Key or Value"
              >
              </validated-text-input>
              <span v-if="transitionError.condition" class="error-message">{{ transitionError.condition }}</span>
            </div>
            <!-- Next State Key or value -->
            <div class="md-layout-item md-small-size-100 md-size-20">
              <validated-text-input
                v-model="newCondition.nextStep"
                class="md-layout-item md-small-size-100 md-size-20"
                label="Next State Key or Value"
              >
              </validated-text-input>
              <span v-if="transitionError.nextStep" class="error-message">{{ transitionError.nextStep }}</span>
            </div>
            <!-- Add/Edit -->
            <div class="md-layout-item add-edit-button">
              <md-button class="md-primary md-sm" @click="addCondition">
                {{ editIndex !== null ? "Edit" : "Add" }}
              </md-button>
            </div>
          </div>
          <!-- Display Added Conditions -->
          <div v-if="formData.metadata.conditions.length">
            <div
              v-for="(condition, index) in formData.metadata.conditions"
              :key="index"
              class="condition-item"
            >
              <validated-text-input
                v-model="condition.path"
                :disabled="true"
                class="md-layout-item md-small-size-100 md-size-20"
              >
              </validated-text-input>
              <validated-select-input
                v-model="condition.comparison"
                :disabled="true"
                :options="comparisonOptions"
                class="md-layout-item md-size-20"
              ></validated-select-input>
              <validated-text-input
                v-model="condition.condition"
                :disabled="true"
                class="md-layout-item md-small-size-100 md-size-20"
              >
              </validated-text-input>
              <validated-text-input
                v-model="condition.nextStep"
                :disabled="true"
                class="md-layout-item md-small-size-100 md-size-20"
              >
              </validated-text-input>
              <md-button
                class="md-icon-button md-primary"
                @click="editCondition(index)"
              >
                <md-icon>edit</md-icon>
                <md-tooltip>Edit condition</md-tooltip>
              </md-button>
              <md-button
                class="md-primary md-simple md-danger md-just-icon"
                @click="deleteCondition(index)"
              >
                <md-icon>close</md-icon>
                <md-tooltip>Delete condition</md-tooltip>
              </md-button>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary md-simple" @click="cancelForm()">Cancel</md-button>
            <md-button :disabled="invalid" class="md-primary" @click="saveStep">Save</md-button>
          </md-dialog-actions>
        </div>
      </group-card>
    </ValidationObserver>
  </div>
</template>
<script>
import {GroupCard} from "@/components";
import ValidatedInputs from "@/components/ValidatedInput";
import ValidatedSelectInput from "@/components/ValidatedInput/ValidatedSelectInput";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import {mapGetters, mapActions} from "vuex";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";

export default {
  components: {
    GroupCard,
    ...ValidatedInputs,
    ValidatedSelectInput,
    GroupCardRow,
    ConfirmDialog,
  },
  computed: {
    ...mapGetters("journey", ["currentStep", "parentStepOptions"]),
    cardTitle() {
      return this.formData.id ? "Steps - Edit" : "Steps - Create";
    },
  },
  data() {
    return {
      formData: {
        id: null,
        name: "",
        key: "",
        parent_id: "",
        metadata: {
          details: {
            title: "",
            description: "",
          },
          conditions: [],
        }
      },
      newCondition: {
        path: "",
        comparison: "",
        condition: "",
        nextStep: "",
      },
      comparisonOptions: [">", "<", "=", "!=", ">=", "<="],
      editIndex: null,
      snackbar: {
        show: false,
        icon: "done",
        content: "",
      },
      transitionError: {
        path: "",
        comparison: "",
        condition: "",
        nextStep: "",
      },
      skipTransitionValidation: false,
    };
  },
  watch: {
    newCondition: {
      handler() {
        if(!this.skipTransitionValidation) {
          this.validateTransitionFields();
        }
      },
      deep: true,
    },
  },
  async mounted() {
    const stepId = this.$route.params.step_id;
    this.formData.id = stepId;
    await this.$store.dispatch('journey/fetchCurrentStep', stepId);
    this.formData = this.currentStep;
    await this.$store.dispatch('journey/fetchSteps');
  },
  methods: {
    ...mapActions("journey", ["fetchSteps"]),
    addCondition() {

      this.skipTransitionValidation = false;
      this.validateTransitionFields();

      if (Object.values(this.transitionError).some((error) => error)) return;

      if (this.editIndex !== null) {
        this.formData.metadata.conditions.splice(this.editIndex, 1, {
          ...this.newCondition,
        });
      } else {
        this.formData.metadata.conditions.push({...this.newCondition});
      }
      this.resetForm();
    },
    validateTransitionFields() {
      this.transitionError = {
        path: this.newCondition.path ? "" : "Path is required.",
        comparison: this.newCondition.comparison ? "" : "Comparison is required.",
        condition: this.newCondition.condition ? "" : "Condition state key or value is required.",
        nextStep: this.newCondition.nextStep ? "" : "Next State key or value is required.",
      };
    },
    editCondition(index) {
      this.skipTransitionValidation = false;
      this.clearTransitionValidation();
      this.newCondition = JSON.parse(JSON.stringify(this.formData.metadata.conditions[index]));
      this.editIndex = index;
    },
    async deleteCondition(index) {
      let userAction = await this.$modal.show(ConfirmDialog, {
        title: "Delete condition",
        message: `Are you sure you want to delete this condition?`,
        confirmText: "Delete",
        cancelText: "Cancel",
      });
      if (userAction) {
        this.formData.metadata.conditions.splice(index, 1);
        this.resetForm();
      }
    },
    resetForm() {
      this.skipTransitionValidation = true;
      this.newCondition = {
        path: "",
        comparison: "",
        condition: "",
        nextStep: "",
      };
      this.clearTransitionValidation();
      this.editIndex = null;
    },
    clearTransitionValidation() {
      this.transitionError = {
        path: "",
        comparison: "",
        condition: "",
        nextStep: "",
      };
    },
    cancelForm() {
      this.$router.push("/administration/steps");
    },
    async saveStep() {
      try {
        await this.$store.dispatch('journey/saveStep', this.formData);
        this.snackbar.content = "Step saved successfully";
        this.snackbar.icon = "done";
        this.snackbar.show = true;
        setTimeout(() => {
          this.$router.push("/administration/steps");
        }, 1000);
      } catch (error) {
        console.error(
          "Error saving step:",
          error.response ? error.response.data : error.message
        );
      }
    },
  },
};
</script>
<style scoped>
.condition-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.md-button.md-icon-button.md-primary,
.md-button.md-primary.md-simple.md-danger.md-just-icon {
  cursor: default;
}

.add-edit-button {
  margin-top: 30px;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: -23px;
  display: block;
}
</style>
